import {makeStyles} from "@material-ui/core"
import {ModernTheme} from "../../../../../theme/modern/tokens"

export default makeStyles((theme: ModernTheme) => ({
    stats: {
        display: "grid",
        gridTemplateColumns: "repeat(4, 1fr)",
        gap: "13px",

        "@media (max-width:1180px)": {gridTemplateColumns: "repeat(2, 1fr)"},
        "@media (max-width:640px)": {
            gridTemplateColumns: "1fr",
            "& > $stat__minor": {display: "none"},
        },
    },
    stat__minor: {},
    /**
     * A plain panel. It carried a 3 px accent bar along its bottom edge and,
     * when selected, a 2 px ring in the same colour — four differently tinted
     * glows across the top of the dashboard, which is decoration rather than
     * information: the colours encode nothing a reviewer can act on. The
     * elevation left here is the neutral one every other card on the page uses.
     */
    stat: {
        display: "block",
        width: "100%",
        textAlign: "left",
        background: theme.modern.panel,
        border: `1px solid ${theme.modern.line}`,
        borderRadius: theme.modern.radius,
        padding: "13px 15px",
        boxShadow: theme.modern.shadow,
        // Opts out of the global uppercase button rule. This is a <button> for
        // the click target only — what it contains is a headline figure and its
        // captions, not a label, and text-transform inherits into all of them.
        textTransform: "none",
        cursor: "pointer",
        transition: "box-shadow .12s, transform .12s",
        fontFamily: theme.modern.sans,

        "&:hover": {
            transform: "translateY(-1px)",
            boxShadow: theme.modern.shadowHover,
        },
        // the lift is a hover-only affordance, so on a tablet these four cards
        // gave no sign they were filter buttons at all until the table below
        // changed. Pressing one now reads as a press.
        "&:active": {
            transform: "translateY(0)",
            boxShadow: theme.modern.shadowSegment,
            background: theme.modern.panel2,
        },

        "@media (prefers-reduced-motion: reduce)": {
            transition: "none",
            "&:hover": {transform: "none"},
            "&:active": {transform: "none"},
        },
    },
    /**
     * Selected — this card is filtering the table below it.
     *
     * Carried by weight rather than by colour: a darker border and the recessed
     * fill. `aria-pressed` states it for anyone who cannot see either.
     */
    stat__active: {
        borderColor: theme.modern.ink3,
        background: theme.modern.panel2,

        "&:hover": {borderColor: theme.modern.ink2},
    },
    stat_top: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: "8px",
        minHeight: 12,
    },
    // `.stat .delta.up` from the design — a fixed accent, not a computed trend
    delta: {
        font: `600 10.5px ${theme.modern.mono}`,
        padding: "2px 7px",
        borderRadius: 99,
        background: theme.modern.okSoft,
        color: theme.modern.ok,
        flex: "none",
    },
    microlabel: {
        font: `600 10px/1 ${theme.modern.sans}`,
        letterSpacing: ".12em",
        textTransform: "uppercase",
        color: theme.modern.ink3,
    },
    stat_num: {
        display: "block",
        font: `700 26px/1.1 ${theme.modern.mono}`,
        marginTop: 7,
        letterSpacing: "-.02em",
        color: theme.modern.ink,
    },
    stat_foot: {
        display: "flex",
        alignItems: "flex-end",
        justifyContent: "space-between",
        gap: "8px",
        marginTop: 2,
        minHeight: 26,
    },
    stat_foot_label: {
        fontSize: 11,
        color: theme.modern.ink3,
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
    },
}))
